module.exports = __webpack_public_path__ + "img/ckb_logo.754369ba.png";